import { authDeleteWithBody } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import {
  SlackAppNotificationMappingRequestBody,
  SlackAppNotificationMappingsResponseBody,
} from "@pages/settings/types";

export const deleteSlackAppNotificationMapping = (
  deploymentId: string,
  channel_id: string
) => {
  return authDeleteWithBody<
    SlackAppNotificationMappingRequestBody,
    SlackAppNotificationMappingsResponseBody
  >(`${DEPLOYMENT_URL}/${deploymentId}/slack/channels`, {
    channel_id: channel_id,
  });
};
